export const recommendationSource = urlParams => {
  if (urlParams?.src === 'dashboard' || urlParams?.src === 'recommendations') {
    return urlParams.src
  }

  switch (urlParams?.source) {
    case 'company-dashboard':
      return 'dashboard'
    case 'recommendations-list':
    case 'company-weekly-recommendations-mail':
    case 'company-live-recommendations-mail':
      return 'recommendations'
    default:
      return null
  }
}
